import React, { useState } from 'react';
import DaumPostcode from 'react-daum-postcode';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import '../../styles/CustomModal.css';
import CustomModal from './CustomModal';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
};

const AddMultiStoreModal = ({ isVisible, setVisible }: Props) => {
  const [addressModal, setAddressModal] = useState<boolean>(false);

  const [storeName, setStoreName] = useState<string>('');
  const [sAddress, setAddress] = useState<string>('');
  const [sExtraAddress, setExAddress] = useState<string>('');
  const [sPhoneNm, setPhoneNm] = useState<string>('');

  const onCloseModal = () => {
    setStoreName('');
    setAddress('');
    setExAddress('');
    setPhoneNm('');
    setVisible(false);
  };

  // onChange
  const onChange_storeName = (event: any) => {
    setStoreName(event.target.value);
  };
  const onChange_sAddress = (event: any) => {
    setAddress(event.target.value);
  };
  const onChange_sExtraAddress = (event: any) => {
    setExAddress(event.target.value);
  };
  const onChange_phoneNumber = (event: any) => {
    setPhoneNm(event.target.value);
  };

  // 다음주소검색
  const handleComplete = async (data: any) => {
    let fullAddress = data.address;
    let extraAddress = '';

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
    }
    setAddress(fullAddress);
    setAddressModal(false);
  };
  const handleAddressModalClose = () => {
    setAddressModal(false);
  };

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: 'addMultiStoreModalOverlay',
        modal: 'addMultiStoreModal',
        root: 'customModalRoot',
      }}
      showCloseIcon={true}
      animationDuration={150}>
      <Style>
        <div className="modal">
          <div className="modal_header">
            <div className="headerBar" />
            <h2>멀티매장 추가하기</h2>
          </div>
          <h5 className="comment">
            {
              '멀티매장이란, 동일한 사업자번호에 여러개의 브랜드(업종)를 운영 중인 매장을 말합니다\n간단한 매장정보를 적어주시면 검수 후 멀티매장을 등록해드립니다'
            }
          </h5>
          <div className="modal_content">
            <div className="inputText">
              <div className="title initial">
                <h4>매장명</h4>
                <h5>(필수)</h5>
              </div>
              <input
                type="text"
                placeholder="매장명을 입력해주세요"
                value={storeName}
                onChange={onChange_storeName}
                autoFocus={true}
              />
            </div>
            <div className="inputText">
              <div className="title">
                <h4>매장주소</h4>
                <h5>(필수)</h5>
              </div>
              <div className="address">
                <input
                  type="text"
                  disabled
                  value={sAddress}
                  placeholder="도로명 주소를 입력해주세요"
                  autoFocus={false}
                  style={{ marginBottom: '8px', backgroundColor: '#ffffff' }}
                />
                <button
                  className="searchBox"
                  onClick={() => {
                    setAddressModal(true);
                  }}>
                  <img src={`${process.env.PUBLIC_URL}/svg/ic_search.svg`} alt="search" />
                </button>
              </div>
              <input
                type="text"
                placeholder="상세주소를 입력해주세요"
                value={sExtraAddress}
                onChange={onChange_sExtraAddress}
                autoFocus={false}
              />
            </div>
            <div className="inputText">
              <div className="title">
                <h4>매장 전화번호</h4>
                <h5>(필수)</h5>
              </div>
              <input
                type="text"
                placeholder="매장 전화번호를 입력해주세요"
                value={sPhoneNm}
                onChange={onChange_phoneNumber}
                autoFocus={false}
              />
            </div>
          </div>
          <div className="modal_footer">
            <button className={`submitButton`}>추가 검수 신청하기</button>
          </div>
        </div>
      </Style>
      <CustomModal isVisible={addressModal} setVisible={setAddressModal}>
        <div style={{ display: 'flex' }}>
          <button
            onClick={handleAddressModalClose}
            style={{ marginLeft: 'auto', marginRight: '1%' }}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`} alt="ic" />
          </button>
        </div>
        <DaumPostcode
          onComplete={handleComplete}
          onClose={handleAddressModalClose}
          autoClose
          style={{ height: '54vh' }}
        />
      </CustomModal>
    </Modal>
  );
};

export default AddMultiStoreModal;

const Style = styled.div`
  .modal {
    height: 80vh;
    padding: 4% 8%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .headerBar {
    width: 40px;
    height: 5px;
    background: #4dd2ae;
    border-radius: 10px;
  }
  .modal_header {
    padding-top: 2%;
    display: flex;
    flex-direction: column;
    align-items: center;
    white-space: pre-line;
    h2 {
      font-size: 22px;
      line-height: 32px;
      color: #555555;
      font-weight: 500;
      padding: 16px 0;
    }
  }

  h5.comment {
    font-size: 16px;
    line-height: 32px;
    color: #555555;
    font-weight: 500;
    padding-top: 5%;
    white-space: pre-line;
  }

  .modal_content {
    padding: 6% 0;
  }
  .inputText {
    img {
      cursor: pointer;
    }

    .title {
      padding: 30px 0 6px 0;
      display: flex;
      align-items: center;
      gap: 6px;

      h5 {
        color: #40977f;
        font-weight: 500;
      }
      h4 {
        color: #555555;
      }
    }
    .title.initial {
      padding: 0 0 6px 0;
    }
  }
  .modal_footer {
    padding-bottom: 4%;
  }

  input,
  textarea {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #cecece;
    border-radius: 5px;
  }

  input::placeholder,
  textarea::placeholder {
    color: #a7a7a7;
  }

  textarea {
    min-height: 120px;
  }

  /* 주소검색 */
  .address {
    position: relative;
    .searchBox {
      margin-bottom: 8px;
      position: absolute;
      top: 0;
      bottom: 0;
      padding: 8px 20px;
      border: none;
      background: #4dd2ae;
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
      font-size: 16px;
      font-weight: 700;
      display: flex;
      align-items: center;
      right: 0%;
    }
  }

  .submitButton {
    padding: 8px 12px;
  }

  @media (max-width: 900px) {
    .modal {
      padding: 4%;
    }
    h5.comment {
      padding: 0 10%;
    }
    .modal_footer {
      padding-bottom: 10%;
    }
  }
`;
